import axiosPrivateMl from "./axiosPrivateMl"

export const fetchConnectedPages = async (requestData) => {
  return axiosPrivateMl.post("connected_pages", requestData)
}
